export default __webpack_public_path__ + "static/media/reebok_stimuli_es_phone.1d512ade.mp4";